import { Component, contentChild, effect, ChangeDetectionStrategy } from '@angular/core'
import { MatCard } from '@angular/material/card'

/**
 * Expects a <mat-card> ... </mat-card>
 */
@Component({
  selector: 'lib-dark-card',
  template: '<ng-content></ng-content>',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @use '@angular/material' as mat;

    :host {
      display: block;
      @include mat.card-overrides(
        (
          outlined-outline-width: 0,
          outlined-container-color: var(--mat-sys-surface-container),
        )
      );
    }
  `,
})
export class DarkCardComponent {
  readonly card = contentChild.required(MatCard)

  private readonly applyStyle = effect(() => {
    this.card().appearance = 'outlined'
  })
}
